// extracted by mini-css-extract-plugin
export var closeButton = "contactForm-module--closeButton---pOKR";
export var closeModal = "contactForm-module--closeModal--ZMj18";
export var faqLink = "contactForm-module--faqLink--WzFy2";
export var faqNotice = "contactForm-module--faqNotice--Q0fQh";
export var formContainer = "contactForm-module--formContainer--YgH1z";
export var modalContainer = "contactForm-module--modalContainer--Rqm5n";
export var modalContentWrapper = "contactForm-module--modalContentWrapper--9ad1C";
export var openModal = "contactForm-module--openModal--6qqtu";
export var thankYou = "contactForm-module--thankYou--+cpEf";